<template>
  <div
    class="show_comment_score"
    :class="{ athena_comment_score: theme == 'athena' }"
  >
    <a href="#comments_title">
      <v-star
        :disabled="true"
        :average_rating="average_rating ? average_rating : '0'"
        :font_size="20"
      ></v-star>
      <span v-if="intro_style"> （{{ review_count || "0" }}） </span>
      <span v-else>
        {{ review_count ? review_count + " Reviews" : "Write a review" }}
      </span>
    </a>
  </div>
</template>
<script>
import vStar from "./commentsstar.vue";
export default {
  props: ["average_rating", "review_count", "intro_style", "theme"],
  data() {
    return {};
  },
  components: {
    vStar,
  },
};
</script>
<style scoped lang='scss'>
.show_comment_score {
  font-size: 13px;
  text-decoration: none !important;
  & > a {
    font-size: 13px;
    display: flex;
    align-items: center;
    font-family: "Muli";
    color: #3085c7 !important;
    & > span {
      margin-left: 3px;
    }
    &::v-deep .starWrap .el-rate {
      height: auto;
    }
  }
}
.athena_comment_score {
  &::v-deep {
    .el-rate__icon,
    .el-icon-star-on {
      color: black !important;
      @media screen and(max-width:768px) {
        font-size: 15px !important;
      }
    }
    .el-rate__decimal {
      color: black !important;
    }
  }
  & > a > span {
    margin-left: 0px;
    color: black !important;
    font-size: 18px;
    @media screen and(max-width:768px) {
      font-size: 13px;
    }
  }
}
</style>